import {
  CONTRACT_ID,
  CONTRACT_NUMBER,
  CONTRACTS,
  RESET_STORE,
  VUZ_ID,
} from "../types";

const initialState = {
  contractId: null,
  contracts: null,
  contractNumber: null,
  vuzId: null,
};

export const contractReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CONTRACT_ID:
      return { ...state, contractId: payload };
    case CONTRACTS:
      return { ...state, contracts: payload };
    case CONTRACT_NUMBER:
      return { ...state, contractNumber: payload };
    case VUZ_ID:
      return { ...state, vuzId: payload };
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};
